module.exports = __webpack_public_path__ + "img/電気回路_6_4_4.80c5be48.png";